import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Option} from "../../../domain/select/option";

@Component({
  selector: 'selection-singleoption-sin-binding',
  templateUrl: './singleoption.component.html',
  styleUrls: ['./singleoption.component.scss']
})
export class SingleoptionSinBindingComponent implements OnInit {
    @Input('binding')binding?:boolean;
    @Input('title')title:string;
    @Input('list')list: any;
    @Input('seleccion')seleccion?: any;
    @Output('result')resultado = new EventEmitter<Option>();
    dropdownSettings;
    /* Para binding*/
    @Input('component_id')component_id?:number;
    visible: boolean;

    constructor() { }

    ngOnInit() {
        this.visible = true;
        this.dropdownSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'nombre',
            selectAllText: 'Seleccionar la opcion correcta',
            unSelectAllText: 'Deseleccionar',
            itemsShowLimit: 100,
            allowSearchFilter: true,
            enableCheckAll: false
        };
    }
    onItemSelect(item: any ) {
        this.seleccion = [];
        if(this.binding){
            let aux = this.list.filter(data => item.id === data.id);
            this.seleccion.push(aux[0]);
        } else {
            this.seleccion.push(item);
        }
        this.toForm();
    }
    onItemDeSelect() {
        this.seleccion = [{id:0, nombre: ''}];
        this.toForm();
    }
    toForm(){
        this.resultado.emit(this.seleccion[0]);
    }
    /* para multiples binding*/
    actualizarCombo(){
        try{
            this.onItemSelect(this.list[0]);
            this.toggle();
        }catch (e){}

    }
    toggle(){
        if(this.list.length > 0){
            this.visible = true;
        } else {
            this.visible = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/selects/singleoption/singleoption.component.ts